/**
 * @author Eric Otto
 */

module.exports = {
    init: function ($container) {
        'use strict';

        const wrapper = $container
            ? $container.querySelector('#random-teaser')
            : document.querySelector('#random-teaser');

        if (!wrapper) {
            return;
        }

        const items = wrapper.getElementsByTagName('li'),
            item = items[Math.floor(Math.random() * items.length)],
            image = this.isRetina()
                ? item.getAttribute('data-image-1x')
                : item.getAttribute('data-image-2x');

        item.style.backgroundImage = 'url(' + image + ')';
        item.style.display = 'block';
    },

    isRetina: function () {
        return window.devicePixelRatio === 2;
    }
};
